import { type ContentGroupsFieldsFragment } from '../../__generated__/graphql-client-types';

type CategoryCard = Extract<ContentGroupsFieldsFragment, { __typename?: 'CategoryCard' }>;

export const isCategoryCard = (subject): subject is CategoryCard =>
	Boolean(subject && '__typename' in subject && subject.__typename === 'CategoryCard');
